<app-layout-header></app-layout-header>
<header>
  <h1>{{ title }}</h1>
  <button (click)="clickEmit()" *ngIf="showBtn && !disableBtn" [disabled]="disableBtn">{{ btnName }}</button>
  <!-- <ion-button mode="ios" color="medium" (click)="clickEmit()">{{
    btnName
  }}</ion-button> -->
</header>
